import { DTOForgeProjectArtifactCreateInput, DTOForgeProjectArtifactDeleteInput, DTOForgeProjectArtifactMoveInput, DTOForgeProjectArtifactUpdateInput, } from "./project-artifact";
import { DTOForgeProjectFeatureCreateInput, DTOForgeProjectFeatureDeleteInput, DTOForgeProjectFeatureForkInput, DTOForgeProjectFeatureMoveInput, DTOForgeProjectFeatureUpdateInput, } from "./project-feature";
import { DTOForgeSectionCreateInput, DTOForgeSectionDeleteInput, DTOForgeSectionMoveInput, DTOForgeSectionUpdateInput, } from "./project-section";
import z from "zod";
export const DTOForgeProjectActionFeatureCreate = z.object({
    type: z.literal("FeatureCreate"),
    input: DTOForgeProjectFeatureCreateInput,
});
export const DTOForgeProjectActionFeatureFork = z.object({
    type: z.literal("FeatureFork"),
    input: DTOForgeProjectFeatureForkInput,
});
export const DTOForgeProjectActionFeatureUpdate = z.object({
    type: z.literal("FeatureUpdate"),
    input: DTOForgeProjectFeatureUpdateInput,
});
export const DTOForgeProjectActionFeatureMove = z.object({
    type: z.literal("FeatureMove"),
    input: DTOForgeProjectFeatureMoveInput,
});
export const DTOForgeProjectActionFeatureDelete = z.object({
    type: z.literal("FeatureDelete"),
    input: DTOForgeProjectFeatureDeleteInput,
});
export const DTOForgeProjectActionArtifactCreate = z.object({
    type: z.literal("ArtifactCreate"),
    input: DTOForgeProjectArtifactCreateInput,
});
export const DTOForgeProjectActionArtifactUpdate = z.object({
    type: z.literal("ArtifactUpdate"),
    input: DTOForgeProjectArtifactUpdateInput,
});
export const DTOForgeProjectActionArtifactDelete = z.object({
    type: z.literal("ArtifactDelete"),
    input: DTOForgeProjectArtifactDeleteInput,
});
export const DTOForgeProjectActionArtifactMove = z.object({
    type: z.literal("ArtifactMove"),
    input: DTOForgeProjectArtifactMoveInput,
});
export const DTOForgeProjectActionSectionCreate = z.object({
    type: z.literal("SectionCreate"),
    input: DTOForgeSectionCreateInput,
});
export const DTOForgeProjectActionSectionUpdate = z.object({
    type: z.literal("SectionUpdate"),
    input: DTOForgeSectionUpdateInput,
});
export const DTOForgeProjectActionSectionDelete = z.object({
    type: z.literal("SectionDelete"),
    input: DTOForgeSectionDeleteInput,
});
export const DTOForgeProjectActionSectionMove = z.object({
    type: z.literal("SectionMove"),
    input: DTOForgeSectionMoveInput,
});
export const DTOForgeProjectAction = z
    .discriminatedUnion("type", [
    //features
    DTOForgeProjectActionFeatureCreate,
    DTOForgeProjectActionFeatureFork,
    DTOForgeProjectActionFeatureUpdate,
    DTOForgeProjectActionFeatureDelete,
    DTOForgeProjectActionFeatureMove,
    //artifacts
    DTOForgeProjectActionArtifactCreate,
    DTOForgeProjectActionArtifactUpdate,
    DTOForgeProjectActionArtifactDelete,
    DTOForgeProjectActionArtifactMove,
    //section
    DTOForgeProjectActionSectionCreate,
    DTOForgeProjectActionSectionUpdate,
    DTOForgeProjectActionSectionDelete,
    DTOForgeProjectActionSectionMove,
])
    .and(z.object({
    tId: z.string().optional(),
}));
